import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { scoreColors } from '../../../helpers/utils';

const DetailsHeader = (props) => {
  const { score, details, } = props;
  const scoreClasses = classNames(`details__bets ${scoreColors(score)}`);
  return (
    <div>
      <div className={scoreClasses}>{score}</div>
      <ul className="details__parameters">
        {details.map((detail, idx) => (
          <li key={`${detail} ${idx}`}>{detail}</li>
        ))}
      </ul>
      <style jsx="true">
        {`
          .details__bets {
            float: left;
            margin-right: 20px;
            padding: 30px 15px 15px;
            border-radius: 0 0 5px 5px;
            font-size: 26px;
            font-weight: 700;
            color: #fff;
          }
          ul.details__parameters {
            display: block;
            float: left;
            margin: 35px 0 0;
            padding: 0;
          }
          ul.details__parameters li {
            margin-right: 15px;
            padding: 10px 15px 10px 0;
            border-right: 1px solid #e6e6e6;
            font-weight: 700;
            display: inline-block;
            list-style: none;
          }
          ul.details__parameters li:last-child {
            padding-right: 0;
            margin-right: 0;
            border-right: none;
          }
        `}
      </style>
    </div>
  );
};

DetailsHeader.propTypes = {
  score: PropTypes.number,
  details: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.number
  ])),
}

DetailsHeader.defaultProps = {
  score: null,
  details: [],
};

export default DetailsHeader;
